import { isNotFalsy } from "@flaminem/utils";

import { searchInString } from "src/utils/string.utils";

import { CasePropertyDiff } from "./AlertCaseVersionsDiffModal.types";

export const searchInCasePropertyDiff = (search: string, diff: CasePropertyDiff) =>
  searchInString(search, getPropertyName(diff));

export const getPropertyName = (diff: CasePropertyDiff) => {
  // For additions, original.property is null, so we need to get the property from a version
  const property =
    diff.original.property ||
    Object.values(diff.versions).find((v) => v?.property)?.property ||
    null;

  if (!property) {
    // Fallback: use the path to construct a name
    return diff.path.join(": ");
  }

  return [
    diff.original.element?.configurableType.name,
    diff.original.subElement?.configurableType.name,
    property.property.name,
  ]
    .filter(isNotFalsy)
    .join(": ");
};
